export const getActiveRegistrations = (registrations = []) => registrations.filter(r => {
  if (r.status === 6 || r.status === 5 || r.status === 2) return false;
  return r.status === 3 || r.status === 4 || !r.createdAt;
});

export const getTotalParticipants = (registrations = []) => registrations.reduce((sum, r) => {
  if (!r.createdAt) return sum + (r.pax || 0);
  return sum + (r.participants?.filter(p => p.status !== 4 && p.status !== 5).length || 0);
}, 0);

export const getActiveParticipantsCount = (registrations = []) => getTotalParticipants(getActiveRegistrations(registrations));
